import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import BasicDetails from "./BasicDetails";
import TermsAgreement from "./TermsAgreement";
import tw from "tailwind-styled-components";
import InitialSettlement from "./InitialSettlement";
import { MdClose } from "react-icons/md";
import { useSelector } from "react-redux";
import axios from "axios";
import Config from "../../Config";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ModalHeader } from "../Styles/InputStyles";

const AddMultipleTenantPage = ({ setAddMultipleTenant, selectedData, getListMutate, propId, setIsSelectProperty, route, handleRefresh }) => {

    const bedStatus = selectedData?.bed?.status
    const navigate = useNavigate();
    const user = useSelector((state) => state.UserReducer.user);
    const roomId = selectedData?.bed?.roomId;
    const [step, setStep] = useState(1);
    const [stepOneData, setStepOneData] = useState(null);
    const query = `?propId=${propId}&roomId=${roomId}`;

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const fetchListing = async () =>
        await axios.get(`${Config.apiUrl}/property/info/${query}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        });

    const { isLoading, error, data, refetch, isRefetching } = useQuery(
        ['propertyData', propId, roomId],
        fetchListing,
        {
            enabled: setAddMultipleTenant && step === 1,
        }
    );

    //------- Basic Detail Tenant -------

    const AddBasicDeatilFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/tenant/reserve/multiple/initiate`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };
    const onAddDetailSuccess = (data, variables) => {
        if (data?.data?.isSuccess === true) {
            // toast.success(data?.data?.msg || "Success");
            setStepOneData(variables);
            setStep(step + 1);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onAddDetailError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addBasicDeailLoading, mutate: addBasicDetailMutate, data: firstStepData } =
        useMutation(AddBasicDeatilFunction, {
            onSuccess: onAddDetailSuccess,
            onError: onAddDetailError,
        });


    const tenantId = firstStepData?.data?.tenantId

    //------- Terms & Agreement Tenant -------
    const AddTermsFunction = async (values) => {
        let agreementUrl;
        if (values.rentalType === Config.RENTAL_OPTIONS.SHORT_DURATION) {
            agreementUrl = `${Config.apiUrl}/tenant/add/agreement/short/stay/new`;
        } else {
            agreementUrl = `${Config.apiUrl}/tenant/reserve/multiple`;
        }

        return await axios.post(agreementUrl, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const onTermSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            setStep(step + 1);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onTremError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addTermLoading, mutate: addTermMutate } =
        useMutation(AddTermsFunction, {
            onSuccess: onTermSuccess,
            onError: onTremError,
        });

    // Due List 
    const fetchDueListing = async () =>
        await axios.get(`${Config.apiUrl}/due/tenant/${tenantId}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        });

    const { isLoading: dueListLoading, error: dueListError, data: dueListData, refetch: dueListReftech } = useQuery(
        ['dueData', tenantId],
        fetchDueListing,
        {
            enabled: step === 3,
        }
    );

    //------- Edit Due Tenant -------
    const EditDueFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/due/edit/new`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };
    const onEditDueSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            dueListReftech();
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onEditDueError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editDueLoading, mutate: editDueMutate } =
        useMutation(EditDueFunction, {
            onSuccess: onEditDueSuccess,
            onError: onEditDueError,
        });

    //------- Initial Settlement Tenant -------
    const InitialSettlementFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/tenant/add/initial/settlement`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const InitialSettlementSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setAddMultipleTenant(false)
            //Sukhbir on 3rd Feburary 2026
            //navigate('/tenants/active')
            if (route) {
                handleRefresh();
                //setIsSelectProperty(false)
                //getListMutate()
            }
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const InitialSettlementError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: InitialSettlementLoading, mutate: InitialSettlementMutate } =
        useMutation(InitialSettlementFunction, {
            onSuccess: InitialSettlementSuccess,
            onError: InitialSettlementError,
        });

    const handleClose = () => {
        setStep(1);
        setAddMultipleTenant(false);
        getListMutate();
    };

    const handlePrevButton = () => {
        setStep(1);
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Add Tenant</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                {step === 1 && (
                    <BasicDetails
                        propId={propId}
                        roomId={roomId}
                        onClose={handleClose}
                        data={data}
                        selectedData={selectedData}
                        addBasicDeailLoading={addBasicDeailLoading}
                        addBasicDetailMutate={addBasicDetailMutate}
                        stepOneData={stepOneData}
                        route={route}
                    />
                )}
                {step === 2 && (
                    <TermsAgreement
                        data={data}
                        firstStepData={firstStepData}
                        onClose={handleClose}
                        addTermLoading={addTermLoading}
                        addTermMutate={addTermMutate}
                        stepOneData={stepOneData}
                        handlePrevButton={handlePrevButton}
                        route={route}
                    />
                )}
                {step === 3 && (
                    <InitialSettlement
                        dueListData={dueListData}
                        dueListLoading={dueListLoading}
                        onClose={handleClose}
                        editDueLoading={editDueLoading}
                        editDueMutate={editDueMutate}
                        InitialSettlementLoading={InitialSettlementLoading}
                        InitialSettlementMutate={InitialSettlementMutate}
                        propId={propId}
                        roomId={roomId}
                        tenantId={tenantId}
                        route={route}
                    />
                )}
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;

export default AddMultipleTenantPage;